import React from "react";
import { useState, useEffect, useRef } from "react";

const Timer = ({ fromDate }: { fromDate: Date | undefined }) => {
    const [time, setTime] = useState("00:00");
    const requestRef = useRef<number | undefined>(undefined);
    const previousTimeRef = useRef<number | undefined>(undefined);

    const animate = (currentTime: number) => {
        if (previousTimeRef.current !== undefined && fromDate) {
            const diff = Math.floor((Date.now() - fromDate.getTime()) / 1000);
            const minutes = Math.floor(diff / 60);
            const seconds = diff % 60;
            setTime(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }
        previousTimeRef.current = currentTime;
        requestRef.current = requestAnimationFrame(animate);
    };

    useEffect(() => {
        // Initial calculation
        if (fromDate) {
            const diff = Math.floor((Date.now() - fromDate.getTime()) / 1000);
            const minutes = Math.floor(diff / 60);
            const seconds = diff % 60;
            setTime(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }
        
        // Start animation loop
        requestRef.current = requestAnimationFrame(animate);
        return () => {
            if (requestRef.current) {
                cancelAnimationFrame(requestRef.current);
            }
        };
    }, [fromDate]);

    return <div>{time}</div>;
};

export default Timer;